import React, { Component } from "react";
import MarkdownIt from "markdown-it";
import markdownItAttrs from "markdown-it-attrs";
import markdownItTitle from "markdown-it-title";
import markdownItDecorate from "markdown-it-decorate";
import isUrlRelativeWithoutDomain from "is-url-relative-without-domain";

class PageShow extends Component {
  constructor(props) {
    super(props);

    this.markdown = new MarkdownIt("commonmark", {
      breaks: true,
      linkify: true,
      typographer: true
    })
      .use(markdownItAttrs)
      .use(markdownItTitle)
      .use(markdownItDecorate);

    this.contentEl = null; // will be populated by ref
    this.state = {
      contentRendered: ""
    };
  }

  componentDidMount() {
    // Render content once DOM is set.
    if (this.props.content) {
      this.renderContent_(this.props.content);
    }

    // Intercept all link clicks in content and try to run through the router
    // for faster page loads.
    this.contentEl.addEventListener("click", this.handleContentClick_);
  }

  componentWillUnmount() {
    this.contentEl.removeEventListener("click", this.handleContentClick_);
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.content !== nextProps.content) {
      this.renderContent_(nextProps.content);
    }
  }

  render() {
    return (
      <div className="type-page-show-container" ref={n => (this.contentEl = n)}>
        {/* Need ref to above div to attach listener for clicks. */}
        <div dangerouslySetInnerHTML={this.getContent_()} />
      </div>
    );
  }

  renderContent_(content) {
    const env = {};
    const rendered = this.markdown.render(content, env);
    this.setState({ contentRendered: rendered });
    if (env.title) {
      this.props.setTitle(env.title);
    }
  }

  getContent_() {
    return { __html: this.state.contentRendered };
  }

  handleContentClick_ = e => {
    const link = e.composedPath().filter(el => {
      return el.tagName === "A";
    }); // get first link in path

    // Only use push state if we have a link and it is relative.
    if (link.length > 0) {
      // Need getAttribute to get the literal contents of href.
      const url = link[0].getAttribute("href");
      if (isUrlRelativeWithoutDomain(url)) {
        this.props.history.push(url);
        e.preventDefault();
        e.stopPropagation();
      }
    }
  };
}

export default PageShow;



// WEBPACK FOOTER //
// ./src/components/PageShow.js